import classNames from "classnames";

const notificationClasses = ({ color, readAt }) =>
  classNames(["notification", color, { "notification--unread": !readAt }]);

export default notificationClasses;
